import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { CollapsibleContent, CollapsibleTitle, useCollapsibleState } from 'components/Collapsible';
import { setDynamicAccordionState } from 'features/sort/dynamicPersistenceStore';
import ModelContext from 'features/sort/modelContext';
import isMappedTo from 'features/sort/isMappedTo';

import SortFilterAppliedFilters from './SortFilterAppliedFilters';

import './SortFilterAppliedFiltersCollapsible.scss';

const dynamicPersistanceName = 'appliedFilters';
const SortFilterAppliedFiltersCollapsible = ({
	appliedFilters,
	initiallyOpen = 'true',
	disclosureIconVariant = 'caret'
}) => {

	const dispatch = useDispatch();
	const isCollapsedDynamicState = useSelector((state) => state?.ui?.accordionCollapsed[dynamicPersistanceName]);
	const appliedFilterWithoutPageAttribute = appliedFilters.filter(
		(appliedFilter) => appliedFilter.DisplayAttributeName.toLowerCase() !== 'page'
	);
	const onOpen = () => {

		dispatch(setDynamicAccordionState({ id: dynamicPersistanceName, isCollapsed: false }));

	};
	const onClose = () => {

		dispatch(setDynamicAccordionState({ id: dynamicPersistanceName, isCollapsed: true }));

	};
	const collapsible = useCollapsibleState(
		isCollapsedDynamicState !== undefined ? !isCollapsedDynamicState : initiallyOpen
	);
	const appliedAttributeValuesCount = appliedFilterWithoutPageAttribute.reduce(
		(acc, val) => acc + val.DisplayAttributeValues.length,
		0
	);
	const { setDisplayTypeId } = useContext(ModelContext);
	const showActiveFilters = isMappedTo.set.interfaceType.leftNav(setDisplayTypeId);
	const appliedFiltersHeaderText = `Applied Filters (${appliedAttributeValuesCount})`;
	const activeFiltersHeaderText = 'Active Filters';
	const headerText = showActiveFilters ? activeFiltersHeaderText : appliedFiltersHeaderText;

	return (
		appliedAttributeValuesCount > 0 && (
			<div className="SortFilterAppliedFiltersCollapsible">
				<CollapsibleTitle disclosureIconVariant={disclosureIconVariant} {...collapsible}>
					{headerText}
				</CollapsibleTitle>
				<CollapsibleContent onOpen={onOpen} onClose={onClose} {...collapsible}>
					<SortFilterAppliedFilters appliedFilters={appliedFilterWithoutPageAttribute} />
				</CollapsibleContent>
			</div>
		)
	);

};

SortFilterAppliedFiltersCollapsible.propTypes = {
	appliedFilters: PropTypes.oneOfType([
		PropTypes.arrayOf(
			PropTypes.shape({
				Name: PropTypes.string,
				AttributeValues: PropTypes.arrayOf(PropTypes.string),
				StepbackLink: PropTypes.string
			})
		)
	]).isRequired,
	initiallyOpen: PropTypes.bool,
	disclosureIconVariant: PropTypes.string
};

export default SortFilterAppliedFiltersCollapsible;
